// extracted by mini-css-extract-plugin
export default {"tags":"g4UZvFA6P41UNn_na4ur","triaged":"sF8TPLlkKvcYL3zxp_Yp"};